import {
	collection,
	getDocs
}
from "firebase/firestore";

import { db }
from "../firebase/firebaseConfig";

const generarRutaEstudio =
async (
	userId
) => {

	const [
		temasSnap,
		temaCompSnap,
		progresoSnap
	] = await Promise.all([

		getDocs(
			collection(
				db,
				"materias_temas"
			)
		),

		getDocs(
			collection(
				db,
				"tema_componente"
			)
		),

		getDocs(
			collection(
				db,
				"progreso_temas"
			)
		)
	]);

	const temas =
		temasSnap.docs.map(
			d => d.data()
		);

	const relaciones =
		temaCompSnap.docs.map(
			d => d.data()
		);

	const progresos =
		progresoSnap.docs
			.map(
				d => d.data()
			)
			.filter(
				p =>
				p.userId ===
				userId
			);

	const temasAnalizados =
		temas.map(
			tema => {

				const progreso =
					progresos.find(
						p =>
						Number(
							p.temaId
						) ===
						Number(
							tema.ID
						)
					);

				const total =
					progreso?.totalRespondidas || 0;

				const correctas =
					progreso?.correctas || 0;

				const precision =
					total > 0
						? Math.round(
							(correctas / total) * 100
						)
						: 0;

				let estado =
					"sin_datos";

				if (
					total > 0
				) {

					estado =
						"explorando";
				}

				if (
					total >= 5 &&
					precision >= 70
				) {

					estado =
						"dominado";
				}

				if (
					total >= 5 &&
					precision < 50
				) {

					estado =
						"critico";
				}

				return {

					temaId:
						tema.ID,

					nombre:
						tema.Tema,

					prerrequisitos:
						tema.Prerrequisitos || [],

					estado,

					total,

					precision
				};
			}
		);

	const criticos =
		temasAnalizados.filter(
			t =>
			t.estado ===
			"critico"
		);

	const explorando =
		temasAnalizados.filter(
			t =>
			t.estado ===
			"explorando"
		);

	const sinDatos =
		temasAnalizados.filter(
			t =>
			t.estado ===
			"sin_datos"
		);

	const dominados =
		temasAnalizados.filter(
			t =>
			t.estado ===
			"dominado"
		);

	const temasPrioritarios = [

		...criticos,

		...explorando,

		...sinDatos
	]
	.slice(
		0,
		20
	);

	return {

		totalTemas:
			temasAnalizados.length,

		dominados:
			dominados.length,

		explorando:
			explorando.length,

		criticos:
			criticos.length,

		sinDatos:
			sinDatos.length,

		temasPrioritarios
	};
};

export default
	generarRutaEstudio;